import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DepartmentSecuritySettings } from '../entities/db-issuer.model';
import { DashboardApiService } from './db-api.service';

@Injectable({
  providedIn: 'root',
})
export class MfaStatusService extends DashboardApiService {
  readonly API_URL = `/v1/issuer/organizations/${this.embedding.departmentId}/security_setting`;

  loadMfaStatus(): Observable<DepartmentSecuritySettings> {
    const url = `${this.API_URL}/mfa_status`;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}
